const Colors = {
  N0: '#FFFFFF',
  N25: '#FAFBFC',
  N50: '#F5F6F7',
  N75: '#F2F3F5',
  N100: '#EDEEF0',
  N150: '#E1E2E6',
  N200: '#C8CACF',
  N300: '#B8BABF',
  N400: '#999B9E',
  N500: '#747578',
  N600: '#525254',
  N700: '#434445',
  N800: '#323233',
  N900: '#222222',
  N1000: '#000000',
  brand: '#4f63ff',
  prayer: '#0197A7',
  R500: '#FB414B',
};

export default Colors;
